import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=3698bf6a&"
import script from "./Content.vue?vue&type=script&lang=ts&"
export * from "./Content.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports